import { Button, Result, Typography } from '@arco-design/web-react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * 404 页（页面不存在或已下线）。
 *
 * 为什么要有它：老地址（`/kb`、`/knowledge/assets`、`/knowledge/fullkb`、
 * `/system/integration/open-platform` 等）随功能下线后既不挂 Route 也不做重定向，
 * 必须**显式落到这里**——此前 `*` 兜底是重定向回首页，用户只看到「仪表盘」，
 * 会误以为功能还在、只是被换了位置，也看不出自己敲的地址已经不存在。
 *
 * 落点有两层：管理台布局内的 `*`（带侧栏，登录后正常可见）+ 顶层 `*`（布局外，
 * 例如未登录直接敲老地址时也能看到明确的 404，而不是被静默重定向）。
 */
export default function NotFound() {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const where = `${pathname}${search || ''}`;
  return (
    <Result
      status="404"
      title="页面不存在或已下线"
      subTitle={
        <span>
          地址 <Typography.Text code>{where}</Typography.Text> 不存在，或对应功能已下线（老地址不再做跳转）。
        </span>
      }
      style={{ paddingTop: 120 }}
      extra={
        <Button type="primary" onClick={() => navigate('/dashboard', { replace: true })}>
          返回仪表盘
        </Button>
      }
    />
  );
}
